<template>
<div>
  <template v-for="cabin in category.cabins.data">
    <el-row
      :key="`cabinData_${cabin.id}`"
      type="flex"
      justify="space-between"
      class="category-cabin-container">
      <el-col :span="10" style="position: relative;">
        <pm-carousel-wrapper :cabin="cabin" />
      </el-col>
      <el-col :span="14" class="cabin-text-container">
        <div class="cabin-text">
          <div class="cabin-headline">{{ cabin.cabinName }}</div>
          <div v-html="cabin.description"></div>
          <div><b>{{ cabin.descriptionListHeadline }}</b></div>
          <div v-html="cabin.descriptionList"></div>
        </div>
        <el-row
          type="flex"
          justify="space-between"
          :class="`bottom-row bottom-row-${mediaquery}`">
          <el-row
            type="flex"
            justify="start"
            class="center">
            <template v-if="cabin.tourUrl !== ''">
              <div class="icon-box" @click="open(cabin.tourUrl)">
                <span class="sc-icon sc-icon-360-degrees" />
              </div>
              <div class="cabin-tour-link" @click="open(cabin.tourUrl)">
                <span>{{ $t('deck.link-tour') }}</span>
                <div class="line"></div>
              </div>
            </template>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            class="center">
            <div style="margin-right: 5rem; padding-top: 1rem;">
              <div :id="`category-price-${cabin.id}`" class="price-text">{{ $t('deck.price-text', { duration: schedule.duration - 1 }) }}</div>
              <div class="price">{{ category.price | currencyFormat(category.currency, _self) }}</div>
            </div>
            <div>
              <pm-cabin-buttons
                width:="17.6rem"
                :cabin="cabin"
                :isAvailable="getIsAvailable(cabin)"
                :isWaitingList="getIsCabinReserved(cabin.cabin)"
                :isRealCategory="!category.isVirtual"
                @showDeckplan="setActiveCabin(cabin.id)"
                @gotoIbe="goToIBE(cabin.id, cabin.cabin)"/>
                <div v-if="isActive(cabin.id)" class="triangle"/>
            </div>
          </el-row>
        </el-row>
      </el-col>
    </el-row>
    <el-collapse-transition
      :key="`cabinData_${cabin.cabin}_deckplan`">
      <div v-if="cabin.id === idActiveCabin">
        <div class="deckplan-headline">{{ $t('deck.cabin-select') }}</div>
        <el-row>
          <pm-deckplan-wrapper
            :idxSchedule="idxSchedule"
            :category="category"
            :idCabin="cabin.id"
            :popover-width="480"
            @selectCategory="changeDeck($event)"/>
        </el-row>
        <div class="deckplan-bottom-row">
          <hr class="horizontal-line" />
          <el-row type="flex" justify="space-between">
            <div style="display: flex; justify: start;">
              <div v-for="n in 3" :key="`unit-state_${n}`" style="display: flex;">
                  <div :class="`unit-state state-${n}`"/>
                  <div class="unit-state-text">{{ $t(`deck.unit-state-${n}`) }}</div>
              </div>
            </div>
            <div>
              <pm-border-button
                width="23rem"
                :disabled="selectedUnit === ''"
                :label="getButtonLabel()"
                class="deckplan-button"
                @click="goToIBE(cabin.id, selectedUnit)"/>
            </div>
          </el-row>
        </div>
      </div>
    </el-collapse-transition>
  </template>
</div>
</template>

<script>
import { cabinMixin } from '../utils/cabinMixin'

export default {
  name: 'CabinsDesktop',
  mixins: [cabinMixin]
}
</script>

<style lang="scss">
.unit-state {
  width: 2.5rem;
  height: 2.5rem;
  margin-right: 1.5rem;
}

.unit-state-text {
  font-size: 1.6rem;
  margin-right: 10rem;
}
.state-1 {
  background: #83C45D
}

.state-2 {
  background: #FCD27A
}

.state-3 {
  background: #FF8426
}

.horizontal-line {
  border: 1px solid #CBCBCB;
  margin-bottom: 2rem;
}

.category-cabin-container {
  background-color: #F3F3F3;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
  margin-top: 2rem;

  .cabin-text-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .cabin-text {
    font-size: 1.6rem;
    font-family: "Roboto";
    color: #333333;
    line-height: 2.6rem;
    padding-top: 5.1rem;
    padding-left: 8rem;
    word-break: normal;

    ul {
      padding-left: 1.8rem !important;
    }
  }

  .bottom-row-4 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .bottom-row-5 {
    padding-left: 8rem;
    padding-right: 9.6rem;
  }

  .bottom-row {
    color: #00355E;
    height: 10rem;
    background-color: #C9E3F7;
    font-family: "Roboto";
    align-items: center;

    .center {
      align-items: center;
    }
    .cabin-tour-link {
      text-transform: uppercase;
      font-size: 1.6rem;
      font-weight: 400;
      margin-left: 1.5rem;
      cursor: pointer;
      align-items: center;

      .line {
        content: '';
        margin-top: 0.6rem;
        width: 10rem;
        height: 2px;
        background-color: #00355E;

      }
    }

    .price-text {

      font-size: 1.5rem;
      font-weight: 500;
    }

    .price {
      font-size: 4rem;
      font-weight: 700;
      margin-top: -1rem;
    }

    .triangle {
      margin: 2rem 0 0 5rem;
      width: 0rem;
      height: 0rem;
      -webkit-transform:rotate(360deg);
      border-style: solid;
      border-width: 37px 36.5px 0 36.5px;
      border-color: #C9E3F7 transparent transparent transparent;
      position: absolute;
    }

    .icon-box {
      display: flex;
      height: 5.5rem;
      width: 5.5rem;
      border: 0.1rem solid #00355E;
      justify-content: center;

      .sc-icon {
        color: #00355E;
        font-size: 3.2rem;
        line-height: 3.5rem;
      }

      span {
        margin: 1rem;
      }
    }
  }
}
.cabin-headline {
  font-size: 2.4rem;
  font-family: "Montserrat";
  text-transform: uppercase;
  color: #00355E;
  position: relative;
  padding-bottom: 1.6rem;
  margin-bottom: 3.2rem;
}
.cabin-headline:after {
  content: '';
  position: absolute;
  width: 10rem;
  height: 2px;
  background-color: #00355E;
  left: 0;
  bottom: 0;
  margin-right: auto;
}
.deckplan-headline {
  font-size: 3.8rem;
  font-family: "Montserrat";
  text-transform: uppercase;
  color: #00355E;
  position: relative;
  margin: 13rem 0 3.2rem 9rem;
  padding-bottom: 1.6rem;
}
.deckplan-headline:after {
  content: '';
  position: absolute;
  width: 10rem;
  height: 2px;
  background-color: #00355E;
  left: 0;
  bottom: 0;
  margin-right: auto;
}
.deckplan-bottom-row {
  margin-left: 9rem;
  margin-right: 9.6rem;
  margin-bottom: 10rem;
}
</style>
